module.exports = __webpack_public_path__ + "static/media/pottencial_icon.2f260a7a.svg";